import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from '@/shared/lib/sentry';
import { App } from '@/app/App';
import '@/app.css';

initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
